/**
 * Sincronización de la sesión entre pestañas mediante BroadcastChannel
 */
export const AUTH_SYNC_CHANNEL = 'auth-sync';

/**
 * Identificador de esta pestaña. BroadcastChannel entrega el mensaje a todos los objetos
 * del canal, incluidos los de la misma pestaña, así que se usa para ignorar los mensajes propios.
 * No se usa para nada de seguridad.
 */
export const TAB_ID: string = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
  ? crypto.randomUUID()
  : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

/**
 * Avisar a las otras pestañas que se cambió la entidad de la sesión para que recarguen
 * con el nuevo perfil y token. Llamar después de guardar el perfil en localStorage.
 */
export const notificarCambioEntidad = (): void => {
  if (typeof BroadcastChannel === 'undefined') return;

  const channel = new BroadcastChannel(AUTH_SYNC_CHANNEL);
  channel.postMessage({ type: 'ENTITY_CHANGED', origen: TAB_ID });
  channel.close();
};
